export default "__VITE_ASSET__ac056140__"